import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import RankRow from "@/components/feature/RankRow";
import { topics } from "@/mocks/guaData";
import { formatHeat, getCategoryBySlug, getRankedTopics } from "@/utils/content";

export default function HomeRankBoard() {
  const ranked = getRankedTopics("day").slice(0, 10);
  const newEntries = topics.filter((topic) => topic.trend === "new").slice(0, 3);

  return (
    <section className="w-full bg-background-100/60" aria-labelledby="rank-board-title">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="今日榜单"
          title="今日热门吃瓜榜 TOP10"
          description="综合站内阅读、评论互动与近 24 小时讨论增速排序，每小时更新一次。名次浮动越快，说明话题正在持续发酵。"
          linkTo="/rank"
          linkLabel="看完整榜单"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-8">
            <div className="rounded-lg border border-background-200 bg-background-50 p-2 md:p-3">
              <div className="hidden items-center justify-between px-4 pb-2 pt-2 text-xs uppercase tracking-widest text-foreground-400 md:flex">
                <span>排名 / 话题</span>
                <span>热度 / 走势</span>
              </div>
              <div className="flex flex-col divide-y divide-background-200">
                {ranked.map((topic, index) => (
                  <RankRow key={topic.id} topic={topic} rank={index + 1} />
                ))}
              </div>
            </div>
          </div>

          <aside className="flex flex-col gap-6 lg:col-span-4">
            <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
              <h3 className="heading-font flex items-center gap-2 text-base font-bold text-accent-900">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-sparkling-line text-lg leading-none" aria-hidden="true" />
                </span>
                新进榜话题
              </h3>
              <p className="mt-1.5 text-xs text-accent-800/80">刚刚进入讨论视野，热度还在往上走。</p>
              <ul className="mt-4 flex flex-col gap-3">
                {newEntries.map((topic) => {
                  const category = getCategoryBySlug(topic.categorySlug);
                  return (
                    <li key={topic.id} className="rounded-md bg-background-50/80 p-3">
                      <h4 className="text-sm font-semibold leading-snug text-foreground-900">
                        <Link
                          to={`/topic/${topic.id}`}
                          className="cursor-pointer transition-colors hover:text-primary-700"
                        >
                          {topic.title}
                        </Link>
                      </h4>
                      <p className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
                        <span className="rounded-full bg-accent-100 px-2 py-0.5 text-accent-800">
                          {category?.name}
                        </span>
                        {formatHeat(topic.heat)} 热度
                      </p>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="heading-font text-base font-bold text-foreground-950">编辑手记</h3>
              <blockquote className="mt-3 border-l-2 border-primary-400 pl-4 text-sm leading-relaxed text-foreground-600">
                榜单只看“现在有多少人在聊”，不代表事件本身的轻重。遇到信息还不完整的话题，
                建议先看事件脉络那一栏，再决定要不要站队。
              </blockquote>
              <Link
                to="/about"
                className="mt-4 flex cursor-pointer items-center gap-1.5 text-sm text-primary-700 transition-colors hover:text-primary-800"
              >
                了解我们的内容原则
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true" />
                </span>
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}